module.exports = __webpack_public_path__ + "media/images/prizes/icon_remind-2ce668e1963ba2dad473432309b25f25.svg";